import React, { useState } from "react";
import {  AiOutlineInfoCircle } from 'react-icons/ai';
import { useModal } from "../../../../../../../../src/contexts/customModal";


function getConcessionSummary(conc, fee) {
  const safe = (v, fb = 0) => (v == null ? fb : v);

  const resolvePercent = ({ orgOld, org, current, type }) => {

    if (orgOld) return { defined: orgOld, changed: org };
    if (org != null) return { defined: org, changed: org };
    if (!orgOld &&  org ) return { defined: org, changed: org };
    return { defined: current ?? 0, changed: current ?? 0 };
  };

  const calc = ({ orgOld, org, current, amount, concessionParameter }) => {
  const isAmount = concessionParameter === "AMOUNT";
    if (isAmount) {
    const value = org ?? orgOld ?? 0;

    const percent =
      amount && value
        ? ((value / amount) * 100).toFixed(2)
        : 0;

    return {
      defined: percent,
      changed: percent,
      definedAmt: `₹${Number(value).toFixed(2)}`,
      changedAmt: `₹${Number(value).toFixed(2)}`,
      isAmount: true,
    };
  }


  // Percentage-based flow
  const { defined, changed } = resolvePercent({ orgOld, org, current });

  return {
    defined,
    changed,
    definedAmt: `₹${((defined / 100) * amount).toFixed(2)}`,
    changedAmt: `₹${((changed / 100) * amount).toFixed(2)}`,
    isAmount: false,
  };
};


  return {
    registration: calc({
      orgOld: conc.orgOldRegFeeConcession,
      org: conc.orgRegFeeConcession,
      current: conc.regFeeConcession,
      amount: fee.regFee,
       concessionParameter: conc.concessionParameter,

    }),

    // ✅ ADMIN
    admin: calc({
      orgOld: conc.orgOldAdminFeeConcession,
      org: conc.orgAdminFeeConcession,
      current: conc.adminFeeConcession,
      amount: fee.adminFee,
      concessionParameter: conc.concessionParameter,
    }),

    // ✅ TECH
    tech: calc({
      orgOld: conc.orgOldTechFeeConcession,
      org: conc.orgTechFeeConcession,
      current: conc.techFeeConcession,
      amount: fee.techFee,
      concessionParameter: conc.concessionParameter,
    }),


    // ✅ SAME LOGIC FOR CLASS FEES
    classFees: calc({
      orgOld: conc.orgOldClassFeeConcession,
      org: conc.orgClassFeeConcession,
      current: conc.classFeeConcession,
      amount: fee.classFee,
      concessionParameter: conc.concessionParameter,
    }),

    tuition: calc({
      orgOld: conc.orgOldTutionFeeConcession,
      org: conc.orgTutionFeeConcession,
      current: conc.tutionFeeConcession,
      amount: fee.tutionFee,
      concessionParameter: conc.concessionParameter,
    }),
  };
}


const safe = (value, fallback = "0") =>
  value === null || value === undefined ? fallback : value;

const safeAmount = (value) =>
  value === null || value === undefined ? "₹0.00" : value;

const ConcessionSummary = ({ data = {} }) => {
  
  // Fallback object for all 5 components
  const defaultRow = {
    defined: 0,
    definedAmt: "₹0.00",
    changed: 0,
    changedAmt: "₹0.00",
  };

  const registration = data.registration || defaultRow;
  const admission = data.admin || defaultRow;
  const tuition = data.tuition || defaultRow;
  const classFees = data.classFees || defaultRow;
  const tech = data.tech || defaultRow;

  return (
    <div className=" bg-white p-1 shadow-sm">
      <div className="border rounded-lg overflow-hidden">
        <table className="w-full text-left border-collapse">
          <thead className="bg-[#F9FAFB] text-[#1E1E1E] text-[14px] font-semibold">
            <tr>
              <th className="py-3 px-4 border-b">Component</th>
              <th className="py-3 px-4 border-b">Defined %</th>
              <th className="py-3 px-4 border-b">Changed %</th>
            </tr>
          </thead>

          <tbody className="text-[14px] text-[#1E1E1E]">
            {/* Registration */}
            <tr className="border-b">
              <td className="py-3 px-4">Registration fees:</td>
              <td className="py-3 px-4">
                {safe(registration.defined)}%{" "}
                <span className="text-gray-500">({safeAmount(registration.definedAmt)})</span>
              </td>
              <td className="py-3 px-4">
                {safe(registration.changed)}%{" "}
                <span className="text-gray-500">({safeAmount(registration.changedAmt)})</span>
              </td>
            </tr>

            {/* Admission */}
            <tr className="border-b">
              <td className="py-3 px-4">Admission fees:</td>
              <td className="py-3 px-4">
                {safe(admission.defined)}%{" "}
                <span className="text-gray-500">({safeAmount(admission.definedAmt)})</span>
              </td>
              <td className="py-3 px-4">
                {safe(admission.changed)}%{" "}
                <span className="text-gray-500">({safeAmount(admission.changedAmt)})</span>
              </td>
            </tr>

            {/* Tuition */}
            <tr className="border-b">
              <td className="py-3 px-4">Tuition fees:</td>
              <td className="py-3 px-4">
                {safe(tuition.defined)}%{" "}
                <span className="text-gray-500">({safeAmount(tuition.definedAmt)})</span>
              </td>
              <td className="py-3 px-4">
                {safe(tuition.changed)}%{" "}
                <span className="text-gray-500">({safeAmount(tuition.changedAmt)})</span>
              </td>
            </tr>

            {/* Class Fees */}
            <tr className="border-b">
              <td className="py-3 px-4">Class fees:</td>
              <td className="py-3 px-4">
                {safe(classFees.defined)}%{" "}
                <span className="text-gray-500">({safeAmount(classFees.definedAmt)})</span>
              </td>
              <td className="py-3 px-4">
                {safe(classFees.changed)}%{" "}
                <span className="text-gray-500">({safeAmount(classFees.changedAmt)})</span>
              </td>
            </tr>

            {/* Tech Fees */}
            <tr>
              <td className="py-3 px-4">Tech fees:</td>
              <td className="py-3 px-4">
                {safe(tech.defined)}%{" "}
                <span className="text-gray-500">({safeAmount(tech.definedAmt)})</span>
              </td>
              <td className="py-3 px-4">
                {safe(tech.changed)}%{" "}
                <span className="text-gray-500">({safeAmount(tech.changedAmt)})</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};





const AppliedConcessionDetails = ({
  data,
  row, fee, feeComps
}) => {
  console.log(row, fee, feeComps, "feeComps")



  const { showModal } = useModal();
  const [loading, setLoading] = useState(false);

  const handleOpenModal = async () => {
  const summary =   getConcessionSummary(row, fee)
  console.log(summary, "summary")
      return showModal({
        title: "Concession Summary",
        content: <ConcessionSummary data={summary} />,
      });



  };

  return (
      <AiOutlineInfoCircle
        color="#00B0F5"
        size={16}
        onClick={handleOpenModal}
        style={{ cursor: "pointer", marginLeft:"5px" }}
      />
  );
};

export default AppliedConcessionDetails;
